import { render, staticRenderFns } from "./InviteTeammate.vue?vue&type=template&id=38c6c976&scoped=true&"
import script from "./InviteTeammate.vue?vue&type=script&lang=js&"
export * from "./InviteTeammate.vue?vue&type=script&lang=js&"
import style0 from "./InviteTeammate.vue?vue&type=style&index=0&id=38c6c976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c6c976",
  null
  
)

export default component.exports